import {  ValidationOptions  } from "../../interfaces";

export type ActivationFormFields = "code";

export interface ActivationFormDataType {
  code: number;
}

export interface ActivationFields {
  id: string;
  type: string;
  label: string;
  placeholder: string;
  iconName?: string;
  name: ActivationFormFields;
  validation: ValidationOptions;
}


export const activationFields: Record<
  ActivationFormFields,
  ActivationFields
> = {
  code: {
    label: "Please enter the activation code we’ve just sent to your email.",
    id: "code",
    type: "code",
    name: "code",
    placeholder: "Code",
    validation: {
      required: true,
      maxLength: 6,
      pattern: /^[0-9]{6}$/,
    },
  },
};


export const getCodeErrorMessages = ({
  code,
}: any): Record<string, string> => ({
  required: "The code you entered has expired or is incorrect. Please resend and enter a new code.",
  pattern: "The code you entered has expired or is incorrect. Please resend and enter a new code.",
  maxLength: "The code you entered has expired or is incorrect. Please resend and enter a new code.",
  server: code?.message || "Server error",
});
